<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Registers</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        <router-link to="/user_checks">User Checks</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page" v-if="status">Add Check</li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>Update Check</li>
                </ol>
                <h4 class="main-title mb-0">User Checks</h4>
            </div>
            <div>
                <router-link to="/user_checks" type="button" class="btn btn-danger me-2"><i class="ri-arrow-left-line fs-18 lh-1"></i> Back</router-link>
                <button type="button" v-if="status" class="btn btn-primary me-2" @click="addUserCheck()"><i class="ri-save-line fs-18 lh-1"></i> Submit</button>
                <button type="button" v-else class="btn btn-primary me-2" @click="updateUserCheck()"><i class="ri-save-line fs-18 lh-1"></i> Update</button>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-3">
                <form>
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add User Check</h6>
                            <h6 class="card-title" v-else>Update User Check</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-6">
                                    <label class="form-label">Reference Date</label><span class="text-danger"> *</span>
                                    <input
                                        type="date"
                                        class="form-control"
                                        placeholder="Enter Reference Date"
                                        :class="{'is-invalid': errors.reference_date}"
                                        :value="convertDateFormat(user_check.reference_date)"
                                        v-model="user_check.reference_date"
                                        ref="reference_date"
                                    />
                                    <span v-if="errors.reference_date" class="invalid-feedback">{{ errors.reference_date[0] }}</span>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Asset</label><span class="text-danger"> *</span>
                                    <!-- <search
                                        :disabled="!status"
                                        :class="{ 'is-invalid': errors.asset_id }"
                                        :customClass="{ 'is-invalid': errors.asset_id }"
                                        :initialize="user_check.asset_id"
                                        id="asset_id"
                                        label="asset_name"
                                        label2="asset_code"
                                        placeholder="Select Asset"
                                        :data="assets"
                                        @input=" asset => user_check.asset_id = asset"
                                        @selectsearch="getAssetChecks(user_check.asset_id)"
                                    >
                                    </search> -->
                                    <AssetSearch :disabled="!status" :initialize="user_check.asset_name" @selectAsset="selectAsset($event)"  ref="asset_id"></AssetSearch>
                                    <span v-if="errors.asset_id" class="invalid-feedback">{{ errors.asset_id[0] }}</span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Note</label>
                                    <textarea type="text" placeholder="Enter Note" class="form-control" :class="{'is-invalid': errors.note}" v-model="user_check.note"></textarea>
                                    <span v-if="errors.note" class="invalid-feedback">{{ errors.note[0] }}</span>
                                </div>
                            </div>
                        </div>


                    </div>
                </form>
            </div>
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Asset Checks</h6>
                    </div>
                    <div class="card-body">
                        <div class="row g-2">
                            <div class=" table-responsive">
                                <table class="table table-responsive table-striped  table-sm text-nowrap table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th class="text-center">#</th>
                                            <th>Field name</th>
                                            <th>Field Type</th>
                                            <th>Default Value</th>
                                            <th>Is Required</th>
                                            <th>LCL</th>
                                            <th>UCL</th>
                                            <th>&nbsp;&nbsp;&nbsp;&nbsp;Value&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="check, key in user_check.asset_checks" :key="key">
                                            <td class="text-center">{{ key + 1 }}</td>
                                            <td>{{ check.field_name}}</td>
                                            <td>{{ check.field_type}}</td>
                                            <td>{{ check.default_value}}</td>
                                            <td>{{ check.is_required==1 ? 'Yes' : 'No'}}</td>
                                            <td>{{ check.lcl}}</td>
                                            <td>{{ check.ucl}}</td>
                                            <!-- <td v-if="check.field_type == 'Text'">
                                                <input type="text" placeholder="Enter Value" class="form-control"  v-model="check.value" />
                                            </td>
                                            <td v-if="check.field_type == 'Number'">
                                                <input type="number" placeholder="Enter Value" class="form-control"  v-model="check.value" />
                                            </td>
                                            <td v-if="check.field_type == 'Text Area'">
                                                <textarea type="text" placeholder="Enter Value" class="form-control" v-model="check.value"></textarea>
                                            </td>
                                            <td v-if="check.field_type == 'Date'">
                                                <input type="date" placeholder="Enter Value" class="form-control"  v-model="check.value" />
                                            </td>
                                            <td v-if="check.field_type == 'Date & Time'">
                                                <input type="datetime-local" placeholder="Enter Value" class="form-control"  v-model="check.value" />
                                            </td>
                                            <td v-if="check.field_type == 'Select'">
                                                <select class="form-control" v-model="check.value">
                                                    <option value="">Select</option>
                                                    <option v-for="value, key in check?.field_values?.split(',')" :key="key" :value="value">{{ value }}</option>
                                                </select>
                                            </td> -->

                                             <td>
                <div>
                    <input
                        v-if="check.field_type === 'Text'"
                        type="text"
                        placeholder="Enter Value"
                        class="form-control"
                        v-model="check.value"
                        :class="{'is-invalid': errors[check.field_name]}"
                    />
                    <input
                        v-if="check.field_type === 'Number'"
                        type="number"
                        placeholder="Enter Value"
                        class="form-control"
                        v-model="check.value"
                        :class="{'is-invalid': errors[check.field_name]}"
                    />
                    <textarea
                        v-if="check.field_type === 'Text Area'"
                        placeholder="Enter Value"
                        class="form-control"
                        v-model="check.value"
                        :class="{'is-invalid': errors[check.field_name]}"
                    ></textarea>
                    <input
                        v-if="check.field_type === 'Date'"
                        type="date"
                        placeholder="Enter Value"
                        class="form-control"
                        v-model="check.value"
                        :class="{'is-invalid': errors[check.field_name]}"
                    />
                    <input
                        v-if="check.field_type === 'Date & Time'"
                        type="datetime-local"
                        placeholder="Enter Value"
                        class="form-control"
                        v-model="check.value"
                        :class="{'is-invalid': errors[check.field_name]}"
                    />
                    <select
                        v-if="check.field_type === 'Select'"
                        class="form-control"
                        v-model="check.value"
                        :class="{'is-invalid': errors[check.field_name]}"
                    >
                        <option value="">Select</option>
                        <option v-for="(value, key) in check.field_values.split(',')" :key="key" :value="value">{{ value }}</option>
                    </select>
                    <span v-if="errors[check.field_name]" class="invalid-feedback">{{ errors[check.field_name][0] }}</span>
                </div>
            </td>
                                            <!-- <td></td> -->
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Search from "@/components/Search.vue";
import AssetSearch from "@/components/AssetSearch.vue";
import moment from "moment";
export default {
    name: "UserChecks.Create",
    components: { Search,AssetSearch },
    data(){
        return {
            status:true,
            user_check:{
                user_check_id:'',
                asset_id: '',
                asset_code:"",
                asset_name:"",
                reference_no:'',
                reference_date:'',
                note:'',
                status:'',
                asset_checks:[],
            },
            assets: [],
            status:true,
            asset_checks:[],
            errors:[]
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            // vm.getAssets();
            if (to.name == "UserChecks.Create") {
                if (vm.$store.getters.asset_id) {
                    console.log("vfvfvfvf-")
                    vm.user_check.asset_id = vm.$store.getters.asset_id
                    vm.getAssetChecks(vm.user_check.asset_id)
                }
                vm.$refs.reference_date.focus();
            } else {
                vm.status = false;
                let uri = { uri: "getUserCheck", data: { user_check_id: to.params.user_check_id } };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.user_check = response.data.data;
                        console.log("user-check--",vm.user_check)
                        vm.user_check.asset_id = vm.user_check.asset.asset_id;
                            vm.user_check.asset_code = vm.user_check.asset.asset_code;
                            vm.user_check.asset_name = vm.user_check.asset.asset_name;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            }
        });
    },
    mounted() {
        this.user_check.reference_date = moment().format("yyyy-MM-DD");
    },
    methods: {
        getAssets() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
            .dispatch("post", { uri: "getAssets" })
            .then((response) => {
                loader.hide();
                vm.assets = response.data.data;
            })
            .catch(function (error) {
                loader.hide();
                vm.errors = error.response.data.errors;
                vm.$store.dispatch("error", error.response.data.message);
            });
        },
        getAssetChecks(asset_id){
            let vm = this;
            vm.asset_checks=[];
            let loader = vm.$loading.show();
            vm.$store
            .dispatch("post", { uri: "getAssetChecks", data:{asset_id : asset_id} })
            .then((response) => {
                loader.hide();
                // vm.assets = response.data.data;
                if(response.data.data?.length){
                    let asset_check = response.data.data.filter(function(ele){
                        // vm.asset_checks.push(ele.check)
                        // ele.check.value=ele.check.default_value
                        vm.user_check.asset_checks.push({
                            'check_id': ele.check.check_id,
                            'default_value': ele.check.default_value,
                            'field_name': ele.check.field_name,
                            'field_type': ele.check.field_type,
                            'field_value': ele.check.field_value,
                            'is_required': ele.check.is_required,
                            'field_values': ele.check.field_values,
                            'lcl':ele.check.lcl,
                            'order': ele.check.order,
                            'status': ele.check.status,
                            'ucl':ele.check.ucl,
                            'value': "",
                            'asset_check_id': ele.asset_check_id,

                        })
                    })
                }
            })
            .catch(function (error) {
                loader.hide();
                vm.errors = error.response.data.errors;
                vm.$store.dispatch("error", error.response.data.message);
            });
        },
        addUserCheck(){
            let vm = this;
            let loader = this.$loading.show();
            const errors = {};
             vm.user_check.asset_checks.forEach(check => {
            if (check.is_required == 1 && (!check.value || String(check.value).trim() === '')) {
                    // Use field_name as the key for error messages
                    errors[check.field_name] = errors[check.field_name] || [];
                    errors[check.field_name].push(`Value is required.`);
                }
            });
            // If there are errors, show them and stop the submission
            if (Object.keys(errors).length > 0) {
                loader.hide();
                vm.errors = errors;
                vm.$store.dispatch("error", "Please Add a Check values before submitting.");
                return;
            }
            this.$store.dispatch('post', { uri: 'addUserCheck', data:vm.user_check })
                .then(response => {
                    loader.hide();
                    this.$store.dispatch('success',response.data.message);
                    vm.$router.push("/user_checks");
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        updateUserCheck(){
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'updateUserCheck', data:vm.user_check })
                .then(response => {
                    loader.hide();
                    this.$store.dispatch('success',response.data.message);
                    vm.$router.push("/user_checks");
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        convertDateFormat(date) {
                let vm = this;
                return moment(date).format('yyyy-MM-DD')

        },
            selectAsset(e) {
                const asset = e.target.value;

                this.user_check.asset_name = asset.asset_name;
                this.user_check.asset_id = asset.asset_id;
                this.getAssetChecks(this.user_check.asset_id)

            },


    }
}
</script>